import { t } from 'i18next';
import { useQueryParams } from '../../utils/useQueryParams';
import useArtistQuery from '../api/queries/useArtistQuery';
import { MapFill } from '@peacecover/icon';
import { getContentTypeEmoji, getLocationEventEmoji } from '../../utils/EventUtils';
import HorizontalScroll from '../../presentation/my-page/components/HorizontalScroll';

export const ReportFootprintBreadcrumb = ({ mergeAll = false }: { mergeAll?: boolean }) => {
  const { queryParams } = useQueryParams();

  const artistId = queryParams.get('artistId') || '';
  const memberId = queryParams.get('memberId');
  const spotsCategory = queryParams.get('spotsCategory') || '';
  const locationName = queryParams.get('locationName');
  const contentType = queryParams.get('contentType');

  const artist = useArtistQuery(artistId);
  const member = artist?.members?.find(
    (member: { memberId: string; name: string }) => member.memberId === memberId
  );

  if (mergeAll) {
    return (
      <div className="flex w-fit items-center gap-[4px] h-[24px] rounded-[4px] pl-[7px] pr-[9px] py-1 text-[13px] text-text-primary font-normal bg-surface-lv2">
        <span className="inline-flex w-[13px] h-[13px] shrink-0">
          <img
            src={getLocationEventEmoji(spotsCategory)}
            alt={spotsCategory}
            className="w-full h-full"
          />
        </span>
        {artist?.name} {member?.name}의 {t(`SpotsCategory.${spotsCategory}.value`)}
      </div>
    );
  }

  return (
    <HorizontalScroll>
      <div className="flex items-center gap-[4px] first:ml-[24px] last:mr-[24px]">
        {member ? (
          <div className="flex items-center h-[24px] rounded-[4px] px-[7px] py-1 text-[13px] text-text-primary font-medium bg-secondary-light dark:bg-secondary-dark">
            {artist?.name} {member.name}
          </div>
        ) : (
          <div className="flex items-center h-[24px] rounded-[4px] px-[7px] py-1 text-[13px] text-text-primary font-medium bg-secondary-light dark:bg-secondary-dark">
            {artist?.name}
          </div>
        )}
        {/* 맛집인지 성지인지 카테고리 노출 */}
        {spotsCategory && (
          <div className="flex items-center gap-[4px] h-[24px] rounded-[4px] pl-[7px] pr-[9px] py-1 text-[13px] text-text-main-lv2 font-normal bg-surface-lv2">
            <span className="inline-flex w-[13px] h-[13px] shrink-0">
              <img
                src={getLocationEventEmoji(spotsCategory)}
                alt={spotsCategory}
                className="w-full h-full"
              />
            </span>
            {t(`SpotsCategory.${spotsCategory}.value`)}
          </div>
        )}
        {locationName && (
          <div className="flex items-center gap-[4px] h-[24px] rounded-[4px] pl-[7px] pr-[9px] py-1 text-[13px] text-text-main-lv2 font-normal bg-surface-lv2">
            <MapFill size={14} className="text-on-theirty" />
            {locationName}
          </div>
        )}
        {contentType && (
          <div className="flex items-center gap-[4px] h-[24px] rounded-[4px] pl-[7px] pr-[9px] py-1 text-[13px] text-text-main-lv2 font-normal bg-surface-lv2">
            <span className="inline-flex w-[14px] h-[14px] shrink-0">
              <img
                src={getContentTypeEmoji(contentType)}
                alt={contentType}
                className="w-full h-full"
              />
            </span>
            {t(`ReportFootprintsCategoryPage.category.${contentType}`)}
          </div>
        )}
      </div>
    </HorizontalScroll>
  );
};
